export const SocialTradingProviderIdParamValue = "{providerId}";
export const SocialTradingSubscriptionIdParamValue = "{subscriptionId}";
export const SocialTradingOfferIdParamValue = "{offerId}";

export const ProviderStrategyFieldOptionsMap = {
  Mode: [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Out Only",
      value: "OutOnly",
    },
  ],
};

export const SubscriptionSettingsStrategyFieldOptionsMap = {
  Direction: [
    {
      label: "Direct",
      value: "Direct",
    },
    {
      label: "Reverse",
      value: "Reverse",
    },
  ],
  FundsType: [
    {
      label: "Balance",
      value: "Balance",
    },
    {
      label: "Equity",
      value: "Equity",
    },
  ],
  MinVolumeHandling: [
    {
      label: "Skip",
      value: "Skip",
    },
    {
      label: "MinLot",
      value: "MinLot",
    },
  ],
  Type: [
    {
      label: "AutoScale",
      value: "AutoScale",
    },
    {
      label: "Multiply",
      value: "Multiply",
    },
    {
      label: "Fixed",
      value: "Fixed",
    },
    {
      label: "Lots Proportion",
      value: "LotsProportion",
    },
  ],
};

export const SubscriptionSettingsCorrectionFieldOptionsMap = {
  Action: [
    {
      label: "Skip",
      value: "Skip",
    },
    {
      label: "Scale Down",
      value: "ScaleDown",
    },
  ],
};

export const SubscriptionSettingsFiltersFieldOptionsMap = {
  Direction: [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Buy",
      value: "Buy",
    },
    {
      label: "Sell",
      value: "Sell",
    },
  ],
};

export const SubscriptionRiskFieldOptionsMap = {
  Parameter: [
    {
      label: "Total Loss",
      value: "TotalLoss",
    },
    {
      label: "Total Profit",
      value: "TotalProfit",
    },
    {
      label: "Floating Loss",
      value: "FloatingLoss",
    },
  ],
  SubscriptionAction: [
    {
      label: "Keep",
      value: "Keep",
    },
    {
      label: "Suspend",
      value: "Suspend",
    },
    {
      label: "Unsubscribe",
      value: "Unsubscribe",
    },
  ],
  TradingAction: [
    {
      label: "Close All",
      value: "CloseAll",
    },
    {
      label: "Close Unprofitable",
      value: "CloseUnprofitable",
    },
    {
      label: "Close All Unprofitable",
      value: "CloseAllUnprofitable",
    },
    {
      label: "Keep All",
      value: "KeepAll",
    },
  ],
};

export const providerVisibilityOptions = [
  {
    label: "Public",
    value: "Public",
  },
  {
    label: "Private",
    value: "Private",
  },
];
